<template>
  <SoDialog
    v-model="value"
    :loading="loading"
    card-title="Priority Services Register"
    data-testid="psr-modal"
    @on-close="close"
  >
    <SoTabs v-model="tabIndex" class="pb-8" data-testid="psr-modal-tabs">
      <SoTab title="Vulnerabilities" data-testid="psr-modal-tab-vulnerability">
        <PsrCustomerVulnerabilitiesTable
          :is-services-tab-clicked="tabIndex === 1"
          @cancel="close"
          @submit="tabIndex = 1"
          @is-valid="setIsVulnerabilitiesValid($event)"
        />
      </SoTab>
      <SoTab title="Services" :disabled="!isVulnerabilitiesValid">
        <PsrCustomerServices @cancel="close" @submit="close" />
      </SoTab>
    </SoTabs>
  </SoDialog>
</template>

<script lang="ts">
  import SoTab from "@/components/tabs/SoTab.vue"
  import { defineComponent } from "vue"
  import SoTabs from "@/components/tabs/SoTabs.vue"
  import SoDialog from "@/components/SoDialog.vue"
  import PsrCustomerVulnerabilitiesTable from "../components/PsrCustomerVulnerabilitiesTable.vue"
  import PsrCustomerServices from "@/views/customer/overview/modals/PsrCustomerServices.vue"

  export default defineComponent({
    components: {
      PsrCustomerServices,
      SoTabs,
      SoTab,
      SoDialog,
      PsrCustomerVulnerabilitiesTable,
    },
    props: {
      modelValue: {
        type: Boolean,
        default: false,
        required: true,
      },
    },
    emits: ["update:modelValue"],
    data() {
      return {
        tabIndex: 0,
        isVulnerabilitiesValid: true,
      }
    },
    computed: {
      value: {
        get() {
          return this.modelValue
        },
        set(value: boolean) {
          this.$emit("update:modelValue", value)
        },
      },
      loading() {
        return false
      },
    },
    mounted() {
      this.tabIndex = 0
    },
    methods: {
      setIsVulnerabilitiesValid(value: boolean | null) {
        this.isVulnerabilitiesValid = value ?? false
      },
      close() {
        this.value = false
        this.tabIndex = 0
      },
    },
  })
</script>
